import React, { useEffect, useState } from 'react'
import axios from "axios"
import { v4 as uuidv4 } from 'uuid';
import init from '../firebase';
import { collection, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';

const Subscriptions = () => {
    const [data, setData] = useState({})
    const subcription_id = "0HiF6hiHf6vcK1rstyuV"
    const getSubscriptions = async () => {
        try {
            const mycollection = doc(init.db, 'configuration', subcription_id);
            const data = await getDoc(mycollection);
            setData(data.data())
        } catch (error) {
            console.log(`Error ${error} `)
        }
    }
    // console.log('my subscription data', data)
    useEffect(() => {
        getSubscriptions()
    }, [subcription_id])

    const btnHandler = async () => {

        let orderId = uuidv4()
        let paymentReq = {
            order_id: orderId,
            amount: data?.merchant_subcription_amount,
            currency: "INR",
            payment_capture: 1
        }
        try {
            let result = await axios.post("https://eventplanet.cyclic.cloud/create", paymentReq, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            if (!result.data.data) {
                alert('Something went wrong')
                return
            } else {
                var options = {
                    "key": "rzp_live_6XXCRghG3I98Mm",
                    "amount": result.data.data.amount,
                    "currency": result.data.data.currency,
                    "name": "Event Planet",
                    "description": "Acchi Wali Feeling",
                    "image": "https://eventplanet.in/assets/home/logo_main.png",
                    "order_id": result.data.data.id,
                    "handler": function (response) {
                        alert("Payment successful")
                        // alert(response.razorpay_payment_id);
                        // alert(response.razorpay_order_id);
                        // alert(response.razorpay_signature)
                    },
                    "prefill": {
                        "name": "Test User",
                        "email": "test@gmail.com",
                        "contact": "1234567890"
                    },
                    "notes": {
                        "address": ""
                    },
                    "theme": {
                        "color": "#3399cc"
                    }
                };
                let paymentObj = new window.Razorpay(options)
                paymentObj.open()
            }
        } catch (err) {
            console.log("Error", err)
        }
    }
    return (
        <div className='page-wrapper'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='table-responsive '>
                                    <table className='table table-bordered text-center table-hover  padding-bottom: 100px'>
                                        <thead >
                                            <tr className='' style={{ backgroundColor: '#085f9a' }}>
                                                <th className='text-white'>Subscription Charge: {data?.merchant_subcription_amount}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <center><button className='btn btn-md  text-white' style={{ backgroundColor: '#085f9a' }} onClick={btnHandler}>Subscribe Now</button></center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Subscriptions